<template>
  <div class="bossindex">
    <!--店铺列表-->
    <div class="shop_list">
      <Card
        class="card"
        v-for="(k ,v) in shopList"
        :key="v"
        @click.native="changeShop(k)"
        v-if="k.isgeneralwarehouse!='Y'"
      >
        <p slot="title" class="ShopTitle" :title="k.name">
          <img class="shipImg" src="../../assets/img/default.png" v-if="k.imgurl==''" />
          <img class="shipImg" v-else :src="k.imgurl" />
          {{k.name}}
        </p>
        <a href="###" slot="extra">
          <Dropdown>
            <a href="javascript:void(0)">
              <Icon type="md-more" size="20" />
            </a>
            <DropdownMenu slot="list" trigger="click">
              <DropdownItem>
                <div @click.stop="delModalThat(k.id)">删除</div>
              </DropdownItem>
              <DropdownItem>
                <div @click.stop="editModalThat(k.id)">修改</div>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </a>
        <ul>
          <li>
            <p>联系方式:{{k.phone}}</p>
            <p :title="k.address">店铺地址:{{k.address}}</p>
          </li>
        </ul>
      </Card>
      <Card class="card" id="addShop" v-if="isShowAdd">
        <img @click="editModalThat()" src="../../assets/img/tools/tool.png" />
      </Card>
      <Spin v-if="loadings" size="large" fix></Spin>
    </div>
    <template>
      <Modal v-model="addShopModal" title="店铺信息">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
          <FormItem label="店铺名称" prop="name">
            <Input v-model="formValidate.name" :maxlength="32" placeholder="输入店面名称"></Input>
          </FormItem>
          <FormItem label="地址" prop="address">
            <Input v-model="formValidate.address" :maxlength="50" placeholder="输入店面地址"></Input>
          </FormItem>
          <FormItem label="电话" prop="tel">
            <Input v-model.number="formValidate.tel" placeholder="输入店面电话"></Input>
          </FormItem>
          <FormItem>
            <Alert type="warning" show-icon>请填写正确信息与打印小票关联</Alert>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="text" @click="calladdShopModal()">取消</Button>
          <Button type="primary" @click="addbutton()" :loading="loading">
            <span v-if="!loading">{{buttonText}}</span>
            <span v-else>{{buttonTexta}}</span>
          </Button>
        </div>
      </Modal>
      <!--删除确认框-->
      <Modal v-model="delModal" width="360">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>删除提醒</span>
        </p>
        <div style="text-align:center">
          <p>你确定要删除此店铺吗？</p>
          <p>删除店铺不能恢复</p>
        </div>
        <div slot="footer">
          <Button type="error" size="large" long @click="delShop()">删除</Button>
        </div>
      </Modal>
      <!--验证码弹框-->
      <Modal v-model="sendCodeModel" width="300" title="验证码">
        <Input v-model="sendCode" placeholder="请输入手机验证码"></Input>
        <div slot="footer">
          <Button type="text" @click="sendCodeModel=false">取消</Button>
          <Button type="error" @click="isVerification()">确定</Button>
        </div>
      </Modal>
    <div class="root">

    </div>      
    </template>

    <Modal
            @on-cancel="close()"
            footer-hide
            v-model="Advertisement"
            title="提醒"
            width="70%">
        <img src="../../assets/img/pcgg.png" width="100%">
    </Modal>

    <!--提示是否观看视频-->
    <Modal
            v-model="seevideo"
            title="提醒"
            width="360"
            >
       <p>是否观看新手教学视频</p>
       <div slot="footer">
         <Button @click="seevideo=false">稍后再看</Button>
         <Button type="primary" @click="lookvideo()">确定</Button>
       </div>

    </Modal>
    <div class="video_box" v-if="isCloseVideo">
      <!-- <Icon type="md-close-circle" class="close_icon" size="100" @click="isCloseVideo=true" /> -->
      <img src="../../assets/img/close.png" class="close_icon"  @click="closeVideo" />
      <p class="video_txt">掌大师轻松上手</p>
      <video
              id="video"
              src="https://tangyingkeji.oss-cn-beijing.aliyuncs.com/static/zdsvideo.mp4"
              controls="controls"
              autoplay="autoplay"
      >您的浏览器不支持 video 标签。请升级后重试</video>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cid: "",
      id: "",
      sid: "",
      shipId: "",
      navList: [],
      shopList: {},
      delModal: false,
      loadings: false,
      sendCodeModel: false,
      addShopModal: false,
      isShowAdd: false,
      loading: false,
      sendCode: "",
      type: "",
      buttonText: "添加",
      buttonTexta: "加载中",
      formValidate: {
        name: "",
        address: "",
        tel: ""
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "店铺名称不能为空,且不能超过32位字符",
            trigger: "blur"
          }
        ],
        address: [{ required: true, message: "地址不能为空", trigger: "blur" }],
        tel: [{ required: true, message: "电话不能为空", trigger: "blur" }]
      },
      timer:null,
      Advertisement:false,//广告弹框
      seevideo:false,
      isCloseVideo:false,//隐藏视频
    };
  },

  created: function() {
    //DOM更新完之前请求数据
    var userId = JSON.parse(localStorage.getItem("adminUser")).id;
    this.cid = JSON.parse(localStorage.getItem("adminUser")).cid;
    this.sid = JSON.parse(localStorage.getItem("adminUser")).cid;
    this.getShopList(this.cid);

    //将content的缓存关掉
    // console.log("这是路由信息")
    // console.log(this.$router.options.routes)
    // this.closeCache(this.$router.options.routes)
  },


  mounted(){
    /* 判断是否购买服务，没购买就提示购买 */
    const typeCode= JSON.parse(sessionStorage.getItem("typeCode"))
    //const spaceTime= JSON.parse(sessionStorage.getItem("spaceTime"))
    if( typeCode!=100058 ){
      this.timer=setInterval(()=>{
        const typeCodes= JSON.parse(sessionStorage.getItem("typeCode"))
        if(typeCodes==null||typeCodes=='null'){
          this.Advertisement=false
        }else {
          this.Advertisement=true
        }
        console.log('该广告只显示一次，除非重新的登录')
      },1000)
    }
  },
  beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
  },
  methods: {

    //递归调用，循环关闭页面缓存
    //route 路由数组
    // closeCache(route){
    //   if(route&&route.length>0){//
    //     for(let val of route){
    //       if(val.children){//拥有子菜单
    //         this.closeCache(val.children)
    //       }else{
    //         if(val.meta&&val.meta.keepAlive!==undefined){
    //           val.meta.keepAlive = false//关闭所有缓存页面缓存
    //         }
    //       }

    //     }
    //   }
    //   console.log("关闭全部缓存后的页面")
    //   console.log(this.$router.options.routes)

    // },

    //关闭广告
    close(){
        this.seevideo=true
      sessionStorage.setItem("typeCode",  JSON.stringify(null));
    },
    /*观看视频*/
    lookvideo(){
      this.seevideo=false
      this.isCloseVideo=true
    },

    closeVideo() {
       document.getElementById("video").pause();
      this.isCloseVideo=false
    },

    changeShop(shop) {
      
      if (!shop) return;
      let cid = JSON.parse(localStorage.getItem("adminUser")).cid;
      let form = {
        cid: cid,
        sid: shop.id,
        mark: 0
      };
      //    form = this.$qs.stringify(form)
      this.$Api.getTypeList(form).then(res => {
        localStorage.setItem("goodsClassify", JSON.stringify(res.data));
      });
      this.$Api.getColorCategory({ cid: cid }).then(res => {
        localStorage.setItem("colorList", JSON.stringify(res.data));
      });
      this.$Api.getSizeCategory({ cid: cid }).then(res => {
        localStorage.setItem("sizeList", JSON.stringify(res.data));
      });

      this.$Api
        .getStoreInfo({ sid: shop.id })
        .then(res => {
          localStorage.setItem("registerShop", 0);
        })
        .catch(err => {
          localStorage.setItem("registerShop", 1);
        });
      localStorage.setItem("shop", JSON.stringify(shop));
      localStorage.setItem("sid", shop.id);

      //思路一，发现切换店铺后，像vuex中添加数据，缓存页面拿到vuex的数据，在created时刷新页面缓存 this.$forceUpdate();
      // console.log("我设置了vuex的值")

      this.$router.push("/content");

    },
    
    //获取列表
    getShopList(id) {
      this.loadings = true;
      var data = {
        cid: id,
        page: 1,
        rows: 10
      };
      this.$Api.getShopList(data).then(res => {
        this.shopList = res.data;
        this.loadings = false;
        this.isShowAdd = true;
      });
    },
    //确认添加按钮
    addbutton() {
      let addshopData = {
        name: this.formValidate.name,
        phone: this.formValidate.tel,
        address: this.formValidate.address,
        imgurl: "",
        cid: this.cid
      };
      let addshopDatas = {
        name: this.formValidate.name,
        phone: this.formValidate.tel,
        address: this.formValidate.address,
        id: this.id
      };
      var name = this.formValidate.name;
      var address = this.formValidate.address;
      var tel = this.formValidate.tel;
      if (name == "") {
        this.$Message.warning("店铺名字必填");
        return;
      }
      if (address == "") {
        this.$Message.warning("地址必填");
        return;
      }

      if (tel == "") {
        this.$Message.warning("电话号码必填");
        return;
      }
      var telReg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
      if (!telReg.test(tel)) {
        this.$Message.info("请输入正确的电话号码");
        return;
      }
      this.loading = true;
      if (this.type == 1) {
        this.$Api
          .updateShop(addshopDatas)
          .then(res => {
            if (res.code == 200) {
              this.$Message.warning("修改成功！");
              this.formValidate.name = "";
              this.formValidate.address = "";
              this.formValidate.tel = "";
              this.type = "";
              this.id = "";
              this.getShopList(this.cid);
            } else {
              this.$Message.warning(res.msg);
            }
            this.loading = false;
            this.addShopModal = false;
          })
          .catch(err => {
            this.loading = false;
            this.$Message.warning(err.msg);
          });
      } else {
        this.$Api
          .addShop(addshopData)
          .then(res => {
            if (res.code == 200) {
              this.$Message.warning("添加成功！");
              this.formValidate.name = "";
              this.formValidate.address = "";
              this.formValidate.tel = "";
              this.type = "";
              this.getShopList(this.cid);
            } else {
              this.$Message.warning(res.msg);
            }
            this.loading = false;
            this.addShopModal = false;
          })
          .catch(err => {
            this.loading = false;
            this.$Message.warning(err.msg);
          });
      }
    },
    delModalThat(id) {
      this.delModal = true;
      this.shopId = id;
    },
    calladdShopModal() {
      this.addShopModal = false;
      this.formValidate.name = "";
      this.formValidate.address = "";
      this.formValidate.tel = "";
    },
    //修改店铺
    editModalThat(id) {
      this.addShopModal = true;
      if (id) {
        this.type = 1;
        this.id = id;
        this.buttonText = "确认修改";
        let postData = {
          id: id
        };
        this.$Api
          .getShopId(postData)
          .then(res => {
            if (res.code == 200) {
              this.formValidate.name = res.data.name;
              this.formValidate.address = res.data.address;
              this.formValidate.tel = res.data.phone;
            } else {
              this.$Message.warning(res.msg);
            }
          })
          .catch(err => {
            this.$Message.warning(err.msg);
          });
      } else {
        this.type = 2;
        this.buttonText = "添加";
      }
    },
    delShop() {
      this.delModal = false;
      let cid = {
        cid: this.cid
      };
      this.$Api.sendCodeByCid(cid).then(res => {
        if (res.code == 200) {
          localStorage.setItem("token", res.data);
          this.$Message.success({
            content: "手机验证码发送成功",
            duration: 3
          });
          this.sendCodeModel = true;
        } else {
          this.$Message.warning(res.msg);
        }
      });
    },
    isVerification() {
      var code = this.sendCode;
      if (code == "") {
        this.$Message.warning("填写验证码！");
        return;
      }
      let delShopCode = {
        code: code
      };
      this.$Api.verification(delShopCode).then(res => {
        if (res.msg == "") {
          this.sendCode = "";
          this.delModal = false;
          this.delShopSend(this.cid);
        } else {
          this.$Message.warning(res.msg);
        }
      });
    },
    delShopSend() {
      let delShopData = {
        cid: this.cid,
        sid: this.shopId
      };
      this.$Api.deleteShop(delShopData).then(res => {
        this.getShopList(this.cid);
        this.shopId = "";
        this.$Message.success("删除成功");
        this.sendCodeModel = false;
      });
    },
    closeMsg() {
      this.$Message.warning("请先选择店铺");
    }
  }
};
</script>


<style lang="scss" scoped>
.bossindex {
  position: relative;
}
.shop_list {
  padding-top: 20px;
  padding-left: 26px;
  overflow: auto;
  height: 65%;
  position: fixed;
  top: 126px;
  .card {
    width: 320px;
    float: left;
    margin: 0px 55px 30px;
    box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.14);
    border-radius: 10px;
    cursor: pointer;
    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.ShopTitle {
  position: relative;
  padding-left: 36px;
  width: 94%;
  overflow: auto;
}
.shipImg {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline;
}

#addShop {
  box-shadow: 0px 0px 0px 0px;
  border-radius: 10px;
  border: dashed 4px #68a1ff;
  height: 127px;
  padding-top: 18px;
  img {
    margin: auto;
    outline: none;
  }
}
.video_box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.4);
}
.video_box video {
  width: 100%;
  height: 100%;
}
.video_txt {
  position: absolute;
  top: 10px;
  width: 100%;
  line-height: 20px;
  font-size: 18px;
  color: #fff;
  text-align: center;
  font-weight: bold;
  letter-spacing: 10px;
}
.close_icon {
  position: absolute;
  width: 48px;
  height: 48px;
  top: 40px;
  right: 40px;
  z-index: 9999;
}
.video_box.hidden {
  display: none;
}

</style>